export default __webpack_public_path__ + "static/media/Calendar.f56cc79c.png";